import httpService from "./httpService";
import utils from "./utils";

export default {

  findById(id) {
    return httpService.get(`/rankingReason/${id}`);
  },

  findAll(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/rankingReason", {params: params});
  },

  insert(form) {
    return httpService.post("/rankingReason", form);
  },

  update(id, form) {
    return httpService.put(`/rankingReason/${id}`, form);
  },

  delete(id) {
    return httpService.delete(`/rankingReason/${id}`);
  },

  changeStatus(id) {
    return httpService.put(`/rankingReason/${id}/changeStatus`);
  }
};



// WEBPACK FOOTER //
// ./src/services/rankingReasonService.js